import { Application } from '@hotwired/stimulus';
import InviewController from './controllers/inview_controller';
import PhotoswipeController from './controllers/photoswipe_controller';
import SelectedTravelHelperController from './controllers/selected_travel_helper_controller';
import ModalController from './controllers/modal_controller';
import ClipboardController from './controllers/clipboard_controller';
import ZenNumbersToHanController from './controllers/zen_numbers_to_han_controller';
import PriceQuantityTotalController from './controllers/price_quantity_total_controller';
import TourArrangementController from './controllers/tour_arrangement_controller';
import TourPricingDocumentController from './controllers/tour_pricing_document_controller';
import SelectedTourArrangementController from './controllers/selected_tour_arrangement_controller';
import FlashController from './controllers/flash_controller';
import ActivityDropdownController from './controllers/activity_dropdown_controller';
import AdminDrawerController from './controllers/admin_drawer_controller';
import BulkDateSettingController from './controllers/bulk_date_setting_controller';
import ImageBulkDownloadController from './controllers/image_bulk_download_controller';
import SplitFormController from './controllers/split_form_controller';
import CopyRequesterToClientController from './controllers/copy_requester_to_client_controller';
import TourScheduleSectionBulkDateController from './controllers/tour_schedule_section_bulk_date_controller';
import SidebarToggleController from './controllers/sidebar_toggle_controller';
import NavCollapseController from './controllers/nav_collapse_controller';
import NavCollapseSectionController from './controllers/nav_collapse_section_controller';
import RevealController from './controllers/reveal_controller';
import RevealGroupController from './controllers/reveal_group_controller';

window.Stimulus = Application.start();
Stimulus.register('inview', InviewController);
Stimulus.register('selected-travel-helper', SelectedTravelHelperController);
Stimulus.register('photoswipe', PhotoswipeController);
Stimulus.register('modal', ModalController);
Stimulus.register('clipboard', ClipboardController);
Stimulus.register('zen-numbers-to-han', ZenNumbersToHanController);
Stimulus.register('price-quantity-total', PriceQuantityTotalController);
Stimulus.register('tour-arrangement', TourArrangementController);
Stimulus.register('tour-pricing-document', TourPricingDocumentController);
Stimulus.register('selected-tour-arrangement', SelectedTourArrangementController);
Stimulus.register('flash', FlashController);
Stimulus.register('activity-dropdown', ActivityDropdownController);
Stimulus.register('admin-drawer', AdminDrawerController);
Stimulus.register('bulk-date-setting', BulkDateSettingController);
Stimulus.register('image-bulk-download', ImageBulkDownloadController);
Stimulus.register('split-form', SplitFormController);
Stimulus.register('copy-requester-to-client', CopyRequesterToClientController);
Stimulus.register('tour-schedule-section-bulk-date', TourScheduleSectionBulkDateController);
Stimulus.register('sidebar-toggle', SidebarToggleController);
Stimulus.register('nav-collapse', NavCollapseController);
Stimulus.register('nav-collapse-section', NavCollapseSectionController);
Stimulus.register('reveal', RevealController);
Stimulus.register('reveal-group', RevealGroupController);
